// ===
// 首頁 slides show
// ===
export const FAKE_SLIDESHOW = [
    {
      "title": "微軟雲端解決方案中心",
      'sub_title': 'Cloud Solution Hub',
      "alias": "slideshow-001",
      "introimage": require('@assets/images/home/banner@2.jpg'),
      "introtext": "借助微軟提供的安全、靈活和高性能的物聯網解決方案，推動您的業務發展。使用智能邊緣和智能雲讓您的數據發揮作用。借助預先構建的行業特定解決方案，打造更好的體驗並尋找新的收入來源。",
      "image": null,
      "description": "AI、雲端、資訊安全\n企業發展競爭力最大關鍵",
      "video": null,
      "link": null,
      "featured": 0,
      "featured_ordering": null,
      "params": {
        "meta": {
          "title": "",
          "keywords": "",
          "description": ""
        },
        "seo": []
      },
      "extrafields": [],
      "created_at": "2021-11-16T08:13:16.000000Z",
      "publish_up": "2021-11-16 08:13:16",
      "publish_down": null,
      "category_title": "Slideshow",
      "category_alias": "slideshow",
      "tags": [],
      "files": []
    },
    {
      "title": "微軟雲端解決方案中心首選代理商",
      'sub_title': 'Cloud Solution Hub',
      "alias": "slideshow-002",
      "introimage": require('@assets/images/home/banner@2.jpg'),
      "introtext": "第二條借助微軟提供的安全、靈活和高性能的物聯網解決方案，推動您的業務發展",
      "image": null,
      "description": "AI、雲端、資訊安全\n企業發展競爭力最大關鍵",
      "video": null,
      "link": null,
      "featured": 0,
      "featured_ordering": null,
      "params": {
        "meta": {
          "title": "",
          "keywords": "",
          "description": ""
        },
        "seo": []
      },
      "extrafields": [],
      "created_at": "2021-11-16T08:13:16.000000Z",
      "publish_up": "2021-11-16 08:13:16",
      "publish_down": null,
      "category_title": "Slideshow",
      "category_alias": "slideshow",
      "tags": [],
      "files": []
    },
    {
      "title": "微軟雲端解決方案中心2",
      'sub_title': 'Cloud Solution Hub2',
      "alias": "slideshow-003",
      "introimage": require('@assets/images/home/banner@2.jpg'),
      "introtext": "第三條借助微軟提供的安全借助預先構建的行業特定解決方案使用智能邊緣和智能雲讓您的數據發揮作用。借助預先構建的行業特定解決方案，打造更好的客戶體驗並尋找新的收入來源。",
      "image": null,
      "description": "AI、雲端、資訊安全\n企業發展競爭力最大關鍵",
      "video": null,
      "link": null,
      "featured": 0,
      "featured_ordering": null,
      "params": {
        "meta": {
          "title": "",
          "keywords": "",
          "description": ""
        },
        "seo": []
      },
      "extrafields": [],
      "created_at": "2021-11-16T08:13:16.000000Z",
      "publish_up": "2021-11-16 08:13:16",
      "publish_down": null,
      "category_title": "Slideshow",
      "category_alias": "slideshow",
      "tags": [],
      "files": []
    },
    {
      "title": "微軟雲端解決方案中心4",
      'sub_title': 'Cloud Solution Hub222',
      "alias": "slideshow-004",
      "introimage": require('@assets/images/home/banner@2.jpg'),
      "introtext": "第四條使用智能邊緣和智能雲讓您的數據發揮作用。借助預先構建的行業特定解決方案打造更好的客戶體驗並尋找新的收入來源",
      "image": null,
      "description": "AI、雲端、資訊安全\n企業發展競爭力最大關鍵",
      "video": null,
      "link": null,
      "featured": 0,
      "featured_ordering": null,
      "params": {
        "meta": {
          "title": "",
          "keywords": "",
          "description": ""
        },
        "seo": []
      },
      "extrafields": [],
      "created_at": "2021-11-16T08:13:16.000000Z",
      "publish_up": "2021-11-16 08:13:16",
      "publish_down": null,
      "category_title": "Slideshow",
      "category_alias": "slideshow",
      "tags": [],
      "files": []
    },
    

]

const fakeIndustry = [
  {
    alias: 'biotechnology',
    title: '生技'
  },
  {
    alias: 'agriculture',
    title: '農業'
  },
  {
    alias: 'government',
    title: '政府'
  },
  {
    alias: 'finance',
    title: '金融'
  },
  {
    alias: 'law',
    title: '法律'
  },
  {
    alias: 'educate',
    title: '教育'
  },
  {
    alias: 'energy',
    title: '能源'
  },
  {
    alias: 'manufacture',
    title: '製造'
  },
  {
    alias: 'architecture',
    title: '建築'
  },
  {
    alias: 'game',
    title: '遊戲'
  },
  {
    alias: 'medical',
    title: '醫療'
  },
  {
    alias: 'telecommunications',
    title: '電信與通訊'
  },
  {
    alias: 'media',
    title: '媒體傳播'
  },
  {
    alias: 'enterprise',
    title: '大型企業'
  },
  {
    alias: 'SMEs',
    title: '中小企業'
  },
]

// ===
// 解決方案
// ===

// export const FAKE__CATEGORY = [
//   [
//     {
//       "alias": "3no6vkc2hztcfrpk",
//       "title": "AI+ML",
//       "description": "",
//       "children": [
//         {
//           "alias": "rbydf2pm7qeq7skd",
//           "title": "影像辨識",
//           "description": "",
//           "children": []
//         },
//         {
//           "alias": "rx2jdej9avnn1dta",
//           "title": "語音辨識",
//           "description": "",
//           "children": []
//         },
//         {
//           "alias": "datfm8wnd6xornyk",
//           "title": "自然語意",
//           "description": "",
//           "children": []
//         },
//         {
//           "alias": "tlpalpbhdlfinwje",
//           "title": "搜尋索引",
//           "description": "",
//           "children": []
//         },
//         {
//           "alias": "fyhbzenbsktm8jyt",
//           "title": "深度學習",
//           "description": "",
//           "children": []
//         },
//         {
//           "alias": "ktlzodkpopedirg0",
//           "title": "整合開發",
//           "description": "",
//           "children": []
//         }
//       ]
//     },
//     {
//       "alias": "if4yppxts4qx8w29",
//       "title": "IoT & Data Analytics",
//       "description": "",
//         children: [
//         {
//           alias: '',
//           title: '所屬全部分類',
//           children: fakeIndustry
//         },
//         {
//           alias: 'data',
//           title: '資料倉儲',
//           children: fakeIndustry
//         },
//         {
//           alias: 'analysis',
//           title: '數據分析',
//           children: fakeIndustry
//         },
//         {
//           alias: 'flow',
//           title: '資料流程',
//           children: fakeIndustry
//         },
//         {
//           alias: 'internet',
//           title: '物聯網',
//           children: fakeIndustry
//         },
//         {
//           alias: 'blockchain',
//           title: '區塊鏈',
//           children: fakeIndustry
//         },
//       ]
//     },
//     {
//       "alias": "x8na2awjhyik6rdl",
//       "title": "DevOps",
//       "description": "",
//       children: [
//         {
//           alias: '',
//           title: '所屬全部分類',
//           children: fakeIndustry
//         },
//         {
//           alias: 'modernization',
//           title: '應用程式和資料現代化',
//           children: fakeIndustry
//         },
//         {
//           alias: 'development',
//           title: '應用程式整合與開發',
//           children: fakeIndustry
//         },
//       ]
//     },
//     {
//       "alias": "a5jrcqjle5hyxmrw",
//       "title": "Infrastructure",
//       "description": "",
//       "children":[
//         {
//           alias: '',
//           title: '所屬全部分類',
//           children: fakeIndustry
//         },
//         {
//           alias: 'security',
//           title: '安全與合規性',
//           children: fakeIndustry
//         },
//         {
//           alias: 'cloud',
//           title: '混合雲端',
//           children: fakeIndustry
//         },
//         {
//           alias: 'storage',
//           title: '儲存與備份',
//           children: fakeIndustry
//         },
//         {
//           alias: 'network',
//           title: '網路與監控',
//           children: fakeIndustry
//         },
//         {
//           alias: 'infrastructure',
//           title: '基礎設施維運',
//           children: fakeIndustry
//         },
//         {
//           alias: 'identity',
//           title: '身份識別與權限控管',
//           children: fakeIndustry
//         }
//       ]
//     },
//     {
//       "alias": "fq1njmbjye0qzkun",
//       "title": "Business Application",
//       "description": "",
//       "children": [
//         {
//           alias: '',
//           title: '所屬全部分類',
//           children: fakeIndustry
//         },
//         {
//           alias: 'application',
//           title: '商務應用程式',
//           children: fakeIndustry
//         },
//         {
//           alias: 'relationship',
//           title: '客戶關係管理系統',
//           children: fakeIndustry
//         },
//         {
//           alias: 'management',
//           title: '企業資源管理系統',
//           children: fakeIndustry
//         },
//         {
//           alias: 'human',
//           title: '人力資源管理系統',
//           children: fakeIndustry
//         },
//         {
//           alias: 'progress',
//           title: '進銷存系統',
//           children: fakeIndustry
//         },
//         {
//           alias: 'professional',
//           title: '專業管理與顧問諮詢',
//           children: fakeIndustry
//         }
//       ]
//     }
//   ]
// ]
// export const FAKE_CATEGORY_ = [
//   {
//     alias: 'AlMl',
//     title: 'AL+ML',
//     children: [
//       {
//         alias: '',
//         title: '所屬全部分類',
//         children: fakeIndustry
//       },
//       {
//         alias: 'video',
//         title: '影像辨識',
//         children: fakeIndustry
//       },
//       {
//         alias: 'speech',
//         title: '語音辨識',
//         children: fakeIndustry
//       },
//       {
//         alias: 'natural',
//         title: '自然語意',
//         children: fakeIndustry
//       },
//       {
//         alias: 'search',
//         title: '搜尋索引',
//         children: fakeIndustry
//       },
//       {
//         alias: 'learning',
//         title: '深度學習',
//         children: fakeIndustry
//       },
//       {
//         alias: 'development',
//         title: '整合開發',
//         children: fakeIndustry
//       }
//     ]
//   },
//   {
//     alias: 'iot',
//     title: 'IoT & Data Analytics',
//     children: [
//       {
//         alias: '',
//         title: '所屬全部分類',
//         children: fakeIndustry
//       },
//       {
//         alias: 'data',
//         title: '資料倉儲',
//         children: fakeIndustry
//       },
//       {
//         alias: 'analysis',
//         title: '數據分析',
//         children: fakeIndustry
//       },
//       {
//         alias: 'flow',
//         title: '資料流程',
//         children: fakeIndustry
//       },
//       {
//         alias: 'internet',
//         title: '物聯網',
//         children: fakeIndustry
//       },
//       {
//         alias: 'blockchain',
//         title: '區塊鏈',
//         children: fakeIndustry
//       },
//     ]
//   },
//   {
//     alias: 'devops',
//     title: 'DevOps',
//     children: [
//       {
//         alias: '',
//         title: '所屬全部分類',
//         children: fakeIndustry
//       },
//       {
//         alias: 'modernization',
//         title: '應用程式和資料現代化',
//         children: fakeIndustry
//       },
//       {
//         alias: 'development',
//         title: '應用程式整合與開發',
//         children: fakeIndustry
//       },
//     ]
//   },
//   {
//     alias: 'infrastructure',
//     title: 'Infrastructure',
//     children: [
//       {
//         alias: '',
//         title: '所屬全部分類',
//         children: fakeIndustry
//       },
//       {
//         alias: 'security',
//         title: '安全與合規性',
//         children: fakeIndustry
//       },
//       {
//         alias: 'cloud',
//         title: '混合雲端',
//         children: fakeIndustry
//       },
//       {
//         alias: 'storage',
//         title: '儲存與備份',
//         children: fakeIndustry
//       },
//       {
//         alias: 'network',
//         title: '網路與監控',
//         children: fakeIndustry
//       },
//       {
//         alias: 'infrastructure',
//         title: '基礎設施維運',
//         children: fakeIndustry
//       },
//       {
//         alias: 'identity',
//         title: '身份識別與權限控管',
//         children: fakeIndustry
//       }
//     ]
//   },
//   {
//     alias: 'business',
//     title: 'Business Application',
//     children: [
//       {
//         alias: '',
//         title: '所屬全部分類',
//         children: fakeIndustry
//       },
//       {
//         alias: 'application',
//         title: '商務應用程式',
//         children: fakeIndustry
//       },
//       {
//         alias: 'relationship',
//         title: '客戶關係管理系統',
//         children: fakeIndustry
//       },
//       {
//         alias: 'management',
//         title: '企業資源管理系統',
//         children: fakeIndustry
//       },
//       {
//         alias: 'human',
//         title: '人力資源管理系統',
//         children: fakeIndustry
//       },
//       {
//         alias: 'progress',
//         title: '進銷存系統',
//         children: fakeIndustry
//       },
//       {
//         alias: 'professional',
//         title: '專業管理與顧問諮詢',
//         children: fakeIndustry
//       }
//     ]
//   }
// ]

export const FAKE_CATEGORY = {
  "category": [
      {
          "alias": "yfzahne98dqyqjrl",
          "title": "AI+ML",
          "description": "",
          "children": [
              {
                  "alias": "gklczr4ty3aqreqi",
                  "title": "影像辨識",
                  "description": "",
                  "children": []
              },
              {
                  "alias": "9ypri2rs1aecvvrx",
                  "title": "語音辨識",
                  "description": "",
                  "children": []
              },
              {
                  "alias": "6nmsrqbg7cy7wlue",
                  "title": "自然語意",
                  "description": "",
                  "children": []
              },
              {
                  "alias": "8istfhdopdjtxhrz",
                  "title": "搜尋索引",
                  "description": "",
                  "children": []
              },
              {
                  "alias": "hxh9y2j2xrkcvnr9",
                  "title": "深度學習",
                  "description": "",
                  "children": []
              },
              {
                  "alias": "wvvvquwwwiwqlug6",
                  "title": "整合開發",
                  "description": "",
                  "children": []
              }
          ]
      },
      {
          "alias": "yogkyr92qtajynrj",
          "title": "IoT & Data Analytics",
          "description": "",
          "children": []
      },
      {
          "alias": "m73jnbqbxodkopeq",
          "title": "DevOps",
          "description": "",
          "children": []
      },
      {
          "alias": "nromlwpdhko3wqol",
          "title": "Infrastructure",
          "description": "",
          "children": []
      },
      {
          "alias": "mnoc7tymtpmt9anr",
          "title": "Business Application",
          "description": "",
          "children": []
      }
  ],
  "industry": [
      {
          "alias": "kfgm8mq1r1vdc5df",
          "title": "animi",
          "description": "Et est nesciunt autem. Sit laborum a rerum alias harum. Quo temporibus quia eius consequuntur rerum.",
          "solution_count": 1
      },
      {
          "alias": "hq6vfbyu9byosrhk",
          "title": "vel",
          "description": "Ea sunt iure omnis earum illum. Ut similique ut ipsa fugiat debitis voluptatum. Impedit exercitationem eos dolorem nesciunt voluptas laboriosam fugit. Cumque non optio aut nam est veniam sint.",
          "solution_count": 2
      },
      {
          "alias": "umytroxsfvqxleka",
          "title": "consequatur",
          "description": "Qui laboriosam nam laboriosam a. Id voluptatem velit aut temporibus enim provident quaerat. Et id magni quas aliquid dicta culpa.",
          "solution_count": 1
      },
      {
          "alias": "u6p5bk1r9b6tjx9u",
          "title": "totam",
          "description": "Dignissimos dolore doloremque sed. Sit veritatis culpa consequatur et ut sed. Dolorum voluptatibus incidunt est non sunt placeat aperiam.",
          "solution_count": 1
      },
      {
          "alias": "v8ulggobcyduraok",
          "title": "voluptatem",
          "description": "Porro aspernatur non aperiam suscipit possimus qui. Sint sed dolore incidunt quas. Veritatis assumenda accusantium reiciendis minus.",
          "solution_count": 0
      }
  ]
}